module.exports = __webpack_public_path__ + "static/media/ideate.ea01e5c2.svg";